import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/academic/school-management`;

export interface SchoolSearchParams {
  id?: number | string;
  name?: string;
  schoolCode?: string;
  franchise?: number | string;
  status?: number | string;
  tagId?: number | string;
  page?: number;
}

class SchoolService {
  search = (params: SchoolSearchParams = {}) =>
    myAxios.get<any>(BASE, { params });
  lookups = () => myAxios.get<any>(`${BASE}/lookups`);
  get = (id: number) => myAxios.get<any>(`${BASE}/${id}`);
  create = (data: any) => myAxios.post<any>(BASE, data);
  update = (id: number, data: any) => myAxios.put<any>(`${BASE}/${id}`, data);
  remove = (id: number) => myAxios.delete<any>(`${BASE}/${id}`);
}

export default new SchoolService();
